import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// import { HashLink as Link } from 'react-router-hash-link';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on component mount
  }, [pathname]);

  return null;
};

export default ScrollToTop;